import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7bc8f355&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bc8f355')) {
      api.createRecord('7bc8f355', component.options)
    } else {
      api.reload('7bc8f355', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7bc8f355&", function () {
      api.rerender('7bc8f355', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/week/index.vue"
export default component.exports